export default __webpack_public_path__ + "static/media/close-white.ed19f18a.svg";